<template>
  <card class="card-stats" :show-footer-line="true" :body-classes="color">
    <b-row slot="header">
      <b-col cols="10">
        <slot>
          <span class="h3 font-weight-bold mb-0" v-if="title">{{title}}</span>
        </slot>
      </b-col>
      <b-col cols="2" v-if="$slots.icon || icon" class="text-right">
        <slot name="icon" class="pl-2">
          <b-icon
              icon="question-circle"
              variant="orange"
              class="mr-1 vertical-align-35"
              v-b-tooltip.hover.top="tooltip">
          </b-icon>
        </slot>
      </b-col>
    </b-row>

    <p class="mt-1 mb-0 text-sm">
      <slot name="footer">

      </slot>
    </p>
  </card>
</template>

<script>
    export default {
        name: "CurrentDataSession",
      components: {

      },
      props: {
        type: {
          type: String,
          default: 'primary'
        },
        title: String,
        icon: String,
        iconClasses: [String, Array],
        color: String,
        tooltip: String,
      },
      data() {
          return {

          }
      }
    }
</script>
